import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ copyright }) => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="col-span-1 lg:col-span-1">
            <h3 className="text-white text-xl font-bold mb-6">Baniuaga Group</h3>
            <p className="text-brand-100 mb-6 max-w-md">
              Contributing to the sustainable development of Timor-Leste through focused business excellence and market-leading subsidiaries.
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/baniuagagroup/" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-blue-600 text-white p-3 rounded-full transition duration-300 flex items-center justify-center">
                <span className="sr-only">Facebook</span>
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/baniuaga-holding" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-blue-700 text-white p-3 rounded-full transition duration-300 flex items-center justify-center">
                <span className="sr-only">LinkedIn</span>
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-white text-sm font-semibold mb-4 uppercase tracking-wide">Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="/" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Home
              </a></li>
              <li><a href="#about" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                About Us
              </a></li>
              <li><a href="#services" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Services
              </a></li>
              <li><a href="#subsidiaries" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Subsidiaries
              </a></li>
              <li><a href="#contact" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Contact Us
              </a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white text-sm font-semibold mb-4 uppercase tracking-wide">Subsidiaries</h3>
            <ul className="space-y-3">
              <li><a href="#gardamor-unip" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Gardamor Unip. Lda
              </a></li>
              <li><a href="https://gardamorisp.com" target="_blank" rel="noopener noreferrer" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Gardamor ISP Lda
              </a></li>
              <li><a href="#rozi-tours" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Rozi Tour and Travel
              </a></li>
              <li><a href="#rozi-fuel" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Rozi Fuel Unip. Lda
              </a></li>
              <li><a href="#rozi-construction" className="text-brand-100 hover:text-white transition duration-300 flex items-center">
                <svg className="h-3 w-3 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
                Rozi Construction Unip. Lda
              </a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white text-sm font-semibold mb-4 uppercase tracking-wide">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="h-5 w-5 text-accent-400 mr-3 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-brand-100">Avenida Presidente Nicolao Lobato no. 159, Fatuhada, Dili, Timor-Leste</span>
              </li>
              <li className="flex items-start">
                <svg className="h-5 w-5 text-accent-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="text-brand-100">+670 7739 9991</span>
              </li>
              <li className="flex items-start">
                <svg className="h-5 w-5 text-accent-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-brand-100">info@baniuagaholding.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-xs">
            {copyright || `© ${year} Baniuaga Group. All rights reserved.`}
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white text-xs transition duration-300">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-gray-500 hover:text-white text-xs transition duration-300">Terms of Service</Link>
            <Link to="/news" className="text-gray-500 hover:text-white text-xs transition duration-300">News & Updates</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;